<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">

  <!-- Main Title Section -->
  <div class="page-title-section">
    <h2>Assurance Prévoyance Obsèques</h2>
  </div>

  <!-- Main Content -->
  <div class="content-section main-content">
    <p>
      Pour éviter aux proches du défunt tout tracas financier lié aux coûts des funérailles, il existe des contrats d'assurance qui permettent d'anticiper le versement d'un capital dédié à leur organisation que l'on appelle l'assurance prévoyance obsèques. Elle permet à son souscripteur de prévoir de son vivant, par un versement unique ou par le biais de cotisations mensuelles ou trimestrelles la part du capital qu'il souhaite dédier à l'organisation de ses obsèques pour lui éviter de peser sur le budget de vos proches lors de son décès et régler une fois pour toute le détail de l'organisation des obsèques (type de cercueil, déroulé de la cérémonie, transport...) et de désigner une entreprise de pompes funèbres pour l'organisation.
    </p>
    <p>
      Finalement, vous avez la liberté de choisir le montant, en général de quelques centaines d'euros au minimum à plus de 30 000 euros, selon vos besoins. Une formule de ce type de contrat propose de prévoir le détail de l'organisation des obsèques (type de cercueil, déroulé de la cérémonie, transport...) et de désigner un bénéficiaire quelconque de votre choix.
    </p>
    <p class="highlight-text">
      Cette assurance ne doit pas être confondue avec : <a href="/assurance-prevoyance-deces" class="link-purple">l'assurance Prévoyance Décès</a>.
    </p>
    <p>
      Le <strong class="text-purple">courtier en Assurance BROKINS</strong> est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <strong class="text-purple">GENERALI, APRIL, AXA SPVIE, SWISSLIFE, MALAKOFF HUMANIS, ALPTIS, POP SANTE, FMA, ASAF & AFPS, HENNER, APVIA MACIF, AVENIR MUTUELLE, IDENTITE MUTUELLE, UCR…</strong>
    </p>
    
    <!-- Devis Button -->
    <div class="devis-button-wrapper">
      <button class="btn-devis" (click)="navigateToComparison()">
        Devis en ligne
      </button>
    </div>
  </div>

</app-page-layout>

